export default __webpack_public_path__ + "static/2023ProspectusCover-9eab29ed2b1cd7999297464576715f48.jpg";